import { Component, ViewChild, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'

import * as moment from 'moment'
moment.locale('fr')

import { Event } from '../../models/event.model'
import { EventForm } from '../../models/event-form.model'
import { Picture } from '../../models/picture.model'

import { EventsEmitterService } from '../../services/events-emitter.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { EventsService } from '../../services/events.service'

import { SuiModalService } from 'ng2-semantic-ui'
import { ConfirmModal } from '../confirm-modal/confirm-modal.component'

import { config } from '../../config/config'
import { ParserService } from '../../services/parser.service';

@Component({
  selector: 'ld-event-form',
  template: require('./event-form.component.html'),
  styles: [require('./event-form.component.css')]
})
export class EventFormComponent implements OnInit, OnDestroy {

  @ViewChild('eventForm') eventForm
  @Input('event') event = new Event()
  @Output('eventChange') eventChange = new EventEmitter<Event>()
  private form = new EventForm()
  private isDateRangeValid = true
  private isFeaturingDateRangeValid = true
  private loadingFiles = false
  private debounceTime = config.debounceTime

  constructor (
      private router: Router,
      private eventsEmitterService: EventsEmitterService,
      private messagesDelegate: MessagesDelegate,
      private eventsService: EventsService,
      private modalService: SuiModalService,
      private parserService: ParserService) {}

  ngOnInit () {
    this.form.fill(this.event)
  }

  checkDateRange () {
    this.isDateRangeValid = !this.form.endAt || moment.utc(this.form.beginAt).isBefore(moment.utc(this.form.endAt))
  }

  checkFeaturingDateRange () {
    this.isFeaturingDateRangeValid = this.form.startFeaturing && this.form.endFeaturing && moment.utc(this.form.startFeaturing).isBefore(moment.utc(this.form.endFeaturing))
  }

  async picturesUpdated (files) {
    this.loadingFiles = true

    for (let i = 0; i < files.length; i++) {
      if (files[i].size >= config.images.maxSize) {
        this.messagesDelegate.add('APP.IMAGE.OVERSIZED')
        continue
      }

      const f = await new Picture().fromInputData(files[i])
      this.form.pictures.push(f)
    }

    this.loadingFiles = false
  }

  removePicture (index) {
    this.form.pictures.splice(index, 1)
  }

  async submitEvent () {
    if (!this.eventForm.valid || !this.isDateRangeValid) {
      this.messagesDelegate.add('APP.INVALID_FORM')
      return
    }

    const editingEvent = this.event.id !== ''

    try {
      this.event = await this.eventsService[this.event.id ? 'put' : 'post'](this.form.toRequestData())
      this.eventChange.emit(this.event)
    } catch (e) {
      this.messagesDelegate.add(e.message)
      return
    }

    if (editingEvent) {
      this.messagesDelegate.add('APP.EVENT.UPDATED')
      this.eventsEmitterService.emit('editing', false)
    } else {
      this.messagesDelegate.add('APP.EVENT.CREATED', true)
      this.router.navigate(['/event', this.event.id])
    }
  }

  deleteEvent () {
    this.modalService
      .open(new ConfirmModal('Suppression', "L'événement sera supprimé. Continuer ?"))
      .onApprove(async () => {
        try {
          await this.eventsService.delete(this.event.id)
          this.messagesDelegate.add('APP.EVENT.DELETED', true)
          this.router.navigate(['/home'])
        } catch (e) {
          this.messagesDelegate.add(e.message)
        }
      })
  }

  // this fix locale switching when using ng-pick-datetime
  ngOnDestroy () {
    moment.locale('fr')
  }

  parseLinks () {
    this.form.body = this.parserService.autolink(this.form.body)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/event-form/event-form.component.ts